import './style.css';
import { Common } from './common.js';
import { ImageUpload } from './image-upload.js';
import { VersionCheck } from './version-check.js';
import { onAuthStateChanged, signInWithPopup, signOut } from 'firebase/auth';
import format from 'string-template';
/* eslint-disable no-undef */
const ENV = __ENV__;
const VER = __VER__;
/* eslint-enable no-undef */
const v2 = VER == 'v2';
const v1Modules = [
    "login" /* Modules.login */,
    "products" /* Modules.products */,
    "brands" /* Modules.brands */,
    "records" /* Modules.records */,
    "pubs" /* Modules.pubs */,
    "pricelist" /* Modules.pricelist */,
    "slides" /* Modules.slides */,
    "reviews" /* Modules.reviews */,
    "report" /* Modules.report */,
    "service" /* Modules.service */,
];
const v2Modules = [
    "login" /* Modules.login */,
    "products" /* Modules.products */,
    "brands" /* Modules.brands */,
    "records" /* Modules.records */,
    "ingredients" /* Modules.ingredients */,
    "ingroups" /* Modules.ingroups */,
    "mappings" /* Modules.mappings */,
    "prompts" /* Modules.prompts */,
    "report" /* Modules.report */,
    "service" /* Modules.service */,
    "search" /* Modules.search */,
    "testperfect" /* Modules.testperfect */,
];
// ------------------------------ main ------------------------------ 
export async function prepareMain() {
    modifyStyles();
    await prepareCommon();
    buildMenu();
    ImageUpload.buildImageUploadDiv();
    displayEnv();
    window.addEventListener('popstate', async () => {
        const vars = Common.getUrlVars();
        const page = vars['page'] || "login" /* Modules.login */;
        await preparePage(page);
    }, false);
    window.onbeforeunload = function (e) {
        if (!Common.moduleLoaded("records" /* Modules.records */))
            return;
        const recordsModule = Common.moduleOrNull("records" /* Modules.records */);
        if (recordsModule.shouldRemoveRecordOperator()) {
            recordsModule.updateRecordOperator(true);
            e.preventDefault();
            // Included for legacy support, e.g. Chrome/Edge < 119
            e.returnValue = true;
        }
    };
    onAuthStateChanged(Common.firebase.auth, async (user) => {
        await Common.fillUser(user);
        await displayMenu();
        const vars = Common.getUrlVars();
        const page = vars['page'] || "login" /* Modules.login */;
        await preparePage(page);
    });
}
function modifyStyles() {
    if (v2) {
        const bodyStyles = document.body.style;
        bodyStyles.setProperty('--color_back', 'var(--color_back_v2)');
        bodyStyles.setProperty('--color_menu', 'var(--color_menu_v2)');
        bodyStyles.setProperty('--color_text', 'var(--color_text_v2)');
        bodyStyles.setProperty('--color_action', 'var(--color_action_v2)');
        bodyStyles.setProperty('--color_action_hover', 'var(--color_action_hover_v2)');
        bodyStyles.setProperty('--color_warn', 'var(--color_warn_v2)');
        bodyStyles.setProperty('--color_warn_hover', 'var(--color_warn_hover_v2)');
        bodyStyles.setProperty('--color_accent', 'var(--color_accent_v2)');
        bodyStyles.setProperty('--color_alert', 'var(--color_alert_v2)');
        bodyStyles.setProperty('--color_disabled', 'var(--color_disabled_v2)');
    }
}
async function prepareCommon() {
    if (v2) {
        const module = await import('./res.v2.js');
        Common.res = module.default;
    }
    else {
        const module = await import('./res.v1.js');
        Common.res = module.default;
    }
    Common.goToPage = goToPage;
    Common.init(v2, ENV);
    ImageUpload.init();
}
function buildMenu() {
    const div = document.getElementById('mainMenu');
    if (div && div.childElementCount == 0)
        div.replaceChildren(Common.elem('div', { id: 'envDiv' }), ...buildMenuModules(v2 ? v2Modules : v1Modules), Common.elem('div', { id: 'versionDiv' }));
}
function buildMenuModules(moduleNames) {
    return moduleNames.map(moduleName => Common.elem('a', { id: `${moduleName}Menu`, onclick: () => goToPage(moduleName), style: 'display: none;' }));
}
async function displayMenu() {
    const mainMenu = document.getElementById('mainMenu');
    if (mainMenu) {
        const menuElems = mainMenu.getElementsByTagName('a');
        for (const elem of menuElems) {
            const moduleName = elem.id.replace('Menu', '');
            const bDisplay = Common.accessAllowed(moduleName);
            elem.style.display = bDisplay ? 'block' : 'none';
        }
    }
}
function displayEnv() {
    Common.toElem(Common.constConfigs.envLabel, 'envDiv');
    Common.displayElem('envDiv', !!Common.constConfigs.envLabel);
}
export async function windowResize() {
    const bNewMobile = window.outerWidth < 1200;
    if (Common.currentPage && Common.moduleLoaded(Common.currentPage))
        (await Common.module(Common.currentPage)).windowResize(bNewMobile);
}
export async function goToPage(page, params) {
    if (page == Common.currentPage)
        return;
    const url = `${window.location.origin}${window.location.pathname}?page=${page}` + (params ? `&${params}` : '');
    history.pushState(null, '', url);
    await preparePage(page);
}
function prepareMenu(page) {
    const mainMenu = document.getElementById('mainMenu');
    if (mainMenu) {
        const menuElems = mainMenu.getElementsByTagName('a');
        for (const elem of menuElems) {
            elem.className = elem.id.startsWith(page) ? 'active' : '';
            elem.innerText = Common.res.PAGE_NAMES[elem.id.replace('Menu', '')];
        }
    }
}
async function preparePage(page) {
    document.title = `${Common.res.title} ${Common.res.PAGE_NAMES[page] || ''}`;
    if (Common.currentPage)
        Common.displayElem(`${Common.currentPage}MainDiv`, false);
    else
        Common.displayElem('loginMainDiv', false);
    Common.currentPage = page;
    if (!Common.user.userId && page != "login" /* Modules.login */) {
        login();
        return;
    }
    prepareMenu(Common.currentPage);
    requiresVersionUpdate();
    try {
        if (Common.accessAllowed(Common.currentPage)) {
            await (await Common.module(Common.currentPage)).prepare();
        }
        else {
            Common.currentPage = "login" /* Modules.login */;
            await (await Common.module(Common.currentPage)).prepare();
        }
    }
    catch (e) {
        console.log(`Cannot load ${Common.currentPage} module`);
        console.log(e);
        Common.currentPage = "login" /* Modules.login */;
        await (await Common.module(Common.currentPage)).prepare();
    }
    windowResize();
}
async function requiresVersionUpdate() {
    if (await VersionCheck.requiresVersionUpdate())
        Common.toElem(format(Common.res.errorVersionUpdateRequiredFormat, [VersionCheck.serverVer, VersionCheck.clientVer]), 'versionDiv');
}
// ------------------------------ dropdown ------------------------------
export async function toggleDropdown(moduleName, prefix) {
    const dropdownDiv = document.getElementById(`${prefix}DropdownDiv`);
    if (!dropdownDiv)
        return;
    const itemsDiv = document.getElementById(`${prefix}DropdownItemsDiv`);
    if (!itemsDiv)
        return;
    const search = Common.getInputElement(`${prefix}DropdownSearch`);
    if (!search)
        return;
    if (Common.curDropdownDiv && Common.curDropdownDiv.classList.contains('show') && Common.curDropdownDiv.id != dropdownDiv.id) {
        Common.curDropdownDiv.classList.toggle('show');
    }
    Common.curDropdownDiv = null;
    dropdownDiv.classList.toggle('show');
    if (!dropdownDiv.classList.contains('show')) {
        // search.removeEventListener('keyup', filterBrandItems);
        search.value = '';
        itemsDiv.replaceChildren();
        return;
    }
    Common.curDropdownDiv = dropdownDiv;
    search.value = '';
    search.addEventListener('keyup', (event) => filterItems(event, prefix));
    itemsDiv.replaceChildren(Common.elem('span', {}, Common.res.lblLoading));
    const elems = await (await Common.module(moduleName)).buildDropdownContent(prefix);
    itemsDiv.replaceChildren(...elems);
    search.focus();
}
export function filterItems(event, prefix) {
    if (event.key === 'Escape') {
        const dropdownBtn = document.getElementById(`${prefix}DropdownBtn`);
        if (dropdownBtn) {
            dropdownBtn.click();
            return;
        }
    }
    const dropdownDiv = document.getElementById(`${prefix}DropdownDiv`);
    if (!dropdownDiv)
        return;
    const itemsDiv = document.getElementById(`${prefix}DropdownItemsDiv`);
    if (!itemsDiv)
        return;
    const search = Common.getInputElement(`${prefix}DropdownSearch`);
    if (!search)
        return;
    const filter = search.value.toLowerCase();
    const items = dropdownDiv.getElementsByTagName('a');
    for (const a of items) {
        const txtValue = (a.textContent || a.innerText).toLowerCase();
        a.style.display = (a.classList.contains('all_id') || a.classList.contains('all_search'))
            ? (filter.length == 0 ? '' : 'none')
            : (filter.length > 0 && txtValue.includes(filter) ? '' : 'none');
    }
}
export function closeDropdown() {
    if (Common.curDropdownDiv) {
        Common.curDropdownDiv.classList.remove('show');
        Common.curDropdownDiv = null;
    }
}
// ------------------------------ popup ------------------------------
export function popupMessageClose() {
    Common.showPopupMessage('');
}
// ------------------------------ image ------------------------------
export function imageUploadClose() {
    ImageUpload.imageUploadClose();
}
export function imageUploadOpen(elemId, elemThumbnailId) {
    ImageUpload.imageUploadOpen(elemId, elemThumbnailId);
}
export async function imageUploadFromUrl() {
    await ImageUpload.imageUploadFromUrl();
}
export async function imageUploadFromFile() {
    await ImageUpload.imageUploadFromFile();
}
// ------------------------------ modules ------------------------------
export async function toPage(moduleName, newpage) {
    await Common.toPage(moduleName, newpage);
}
export async function filter(moduleName, elem) {
    (await Common.module(moduleName)).filter(elem);
}
export async function reread(moduleName) {
    (await Common.module(moduleName)).reread();
}
export async function resubscribe(moduleName) {
    (await Common.module(moduleName)).resubscribe();
}
export async function edit(moduleName, id) {
    await Common.edit(moduleName, id);
}
export async function save(moduleName) {
    (await Common.module(moduleName)).save();
}
export async function savecopy(moduleName) {
    (await Common.module(moduleName)).savecopy();
}
export async function savefinish(_moduleName) {
    await (await Common.module("products" /* Modules.products */)).savefinish();
}
export async function saveproduct(_moduleName) {
    await (await Common.module("products" /* Modules.products */)).saveproduct();
}
export async function del(moduleName) {
    (await Common.module(moduleName)).del();
}
export async function close(moduleName) {
    requiresVersionUpdate();
    (await Common.module(moduleName)).close();
}
export async function viewProduct(productId) {
    await goToPage("products" /* Modules.products */, `productId=${productId}`);
}
export function photoOnChange(elemId) {
    Common.photoOnChange(elemId);
}
// ------------------------------ login ------------------------------
export function login() {
    signInWithPopup(Common.firebase.auth, Common.firebase.provider)
        .then((result) => {
        // // This gives you a Google Access Token. You can use it to access the Google API.
        // const credential = GoogleAuthProvider.credentialFromResult(result);
        // const token = credential.accessToken;
        // // The signed-in user info.
        // const user = result.user;
        // // ...
        // // alert(user.email);
        console.log(result.user.email);
    }).catch(async (error) => {
        // Handle Errors here.
        // const errorMessage = error.message;
        // const errorCode = error.code;
        // // The email of the user's account used.
        // const email = error.email;
        // // The AuthCredential type that was used.
        // const credential = GoogleAuthProvider.credentialFromError(error);
        // // ...
        alert(Common.res.errorLogin + Common.getError(error));
        if (Common.currentPage != "login" /* Modules.login */) {
            await goToPage("login" /* Modules.login */);
        }
    });
}
export function logout() {
    signOut(Common.firebase.auth).then(async () => {
        await Common.clearAllModules();
        // Sign-out successful.
        await goToPage("login" /* Modules.login */);
    }).catch((e) => {
        // An error happened.
        alert(Common.res.errorLogout + Common.getError(e));
    });
}
export function voiceCallToMe(callToMe) {
    Common.voiceCallToMe(callToMe);
}
export function voiceCallTest() {
    Common.voiceCallTest();
}
// ------------------------------ brands ------------------------------
export async function updateStoresArrElement(elem) {
    const storesArr = document.getElementById('stores_arr');
    if (!storesArr)
        return;
    if (!elem)
        storesArr.innerText = '';
    else {
        const arr = Common.parseStoresInfo(elem.value);
        storesArr.innerText = Common.getStoresArrString(arr);
    }
}
// ------------------------------ products ------------------------------
export async function selectProduct() {
    await (await Common.module("products" /* Modules.products */)).selectProduct();
    await goToPage("records" /* Modules.records */, 'reload=1');
}
export async function prodIngredientsChanged(value) {
    await (await Common.module("products" /* Modules.products */)).prodIngredientsChanged(value);
}
// export async function productSuitability() {
//     await (await Common.module(Modules.products)).productSuitability();
// }
export async function productNewSuitability() {
    await (await Common.module("products" /* Modules.products */)).productNewSuitability();
}
export async function formatVolume(elemId) {
    Common.formatVolume(elemId);
}
// ------------------------------ ingredients ------------------------------
export async function showIngredientProducts() {
    (await Common.module("ingredients" /* Modules.ingredients */)).showIngredientProducts();
}
// ------------------------------ ingroups ------------------------------
export async function showIngroupIngredients() {
    (await Common.module("ingroups" /* Modules.ingroups */)).showIngroupIngredients();
}
// ------------------------------ mappings ------------------------------
export async function calculateSuitability(bReport) {
    (await Common.module("mappings" /* Modules.mappings */)).calculateSuitability(bReport);
}
// ------------------------------ records ------------------------------
export async function correctRecord() {
    (await Common.module("records" /* Modules.records */)).correctRecord();
}
export async function markRecordWrong() {
    await (await Common.module("records" /* Modules.records */)).markRecordWrong();
}
export async function chooseProductForRecord() {
    const recordsModule = await Common.module("records" /* Modules.records */);
    const params = recordsModule.getRecordUrlParams();
    if (!params)
        return;
    await goToPage("products" /* Modules.products */, params);
}
export async function confirmProductForRecord() {
    await (await Common.module("records" /* Modules.records */)).confirmProductForRecord();
}
export async function viewRecordProduct() {
    const recordsModule = await Common.module("records" /* Modules.records */);
    const recordId = recordsModule.getId;
    if (!recordId)
        return;
    const recordData = recordsModule.list[recordId];
    await goToPage("products" /* Modules.products */, `productId=${recordData.productID || recordData.s_productID}`);
}
export async function addTestRecord() {
    await (await Common.module("records" /* Modules.records */)).addTestRecord();
}
export async function fixRecordPhotos() {
    (await Common.module("records" /* Modules.records */)).fixRecordPhotos();
}
// ------------------------------ slides ------------------------------
export async function slideActionChanged(value) {
    Common.slideActionChanged(value);
}
// ------------------------------ reviews ------------------------------
export async function addReviewBlock() {
    (await Common.module("reviews" /* Modules.reviews */)).addReviewBlock();
}
// ------------------------------ pubs ------------------------------
export async function correctPub() {
    (await Common.module("pubs" /* Modules.pubs */)).correctPub();
}
export async function approvePub(bApprove) {
    (await Common.module("pubs" /* Modules.pubs */)).approvePub(bApprove);
}
// ------------------------------ search ------------------------------
export async function detectProductBrand() {
    (await Common.module("search" /* Modules.search */)).detectProductBrand();
}
export async function detectProductBrandFeedback(grade) {
    (await Common.module("search" /* Modules.search */)).detectProductBrandFeedback(grade);
}
// ------------------------------ testperfect ------------------------------
export async function testperfectDetect() {
    (await Common.module("testperfect" /* Modules.testperfect */)).detect();
}
